import { IconButton } from '@procurify/ui'
import styled from 'styled-components'

export const ConversationFooterWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${(props) => props.theme.space.small};
`

export const ConversationFooterInputBoxStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.space.small};
  background: ${(props) => props.theme.colors.content.contentBackground};
  border: 1px solid ${(props) => props.theme.colors.form.field.border};
  border-radius: ${(props) => props.theme.typography.pxToRem(8)};
  padding: ${(props) => props.theme.space.medium};
  max-height: ${(props) => props.theme.typography.pxToRem(200)};

  &:focus-within {
    border-color: ${(props) => props.theme.colors.form.field.borderActive};
    box-shadow: 0 ${(props) => props.theme.typography.pxToRem(2)}
      ${(props) => props.theme.typography.pxToRem(4)} rgba(0, 0, 0, 0.2);
  }
`

// Visual resets use !important to guard against legacy Bootstrap/normalize
// global styles on Angular pages, where load order can cause element-level
// rules to override styled-component classes. See CommandInputFieldStyled.
export const ConversationFooterInputFieldStyled = styled.textarea`
  display: block;
  width: 100%;
  box-sizing: border-box;
  min-height: ${(props) => props.theme.typography.pxToRem(24)};
  height: ${(props) => props.theme.typography.pxToRem(24)};
  max-height: ${(props) => props.theme.typography.pxToRem(120)};
  overflow-y: auto;
  resize: none !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  border-radius: 0 !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent !important;
  -webkit-appearance: none !important;
  appearance: none !important;

  font-family: ${(props) => props.theme.fontFamily.body};
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
  line-height: ${(props) => props.theme.typography.pxToRem(24)};
  color: ${(props) => props.theme.colors.text.primary};

  &::placeholder {
    opacity: 1;
    color: ${(props) => props.theme.colors.text.tertiary} !important;
  }
`

export const ConversationFooterBottomRowStyled = styled.div`
  display: flex;
  justify-content: flex-end;
`

// Figma annotates the send action as a primary icon button, a variant the DS
// only ships as secondary; mirror PrimaryButtonStyled's colors locally.
export const ConversationFooterSubmitButtonStyled = styled(IconButton)`
  && {
    color: ${(props) => props.theme.colors.white};
    background-color: ${(props) =>
      props.theme.colors.button.primary.background.default};
    border-color: ${(props) =>
      props.theme.colors.button.primary.background.default};
  }

  &&:hover {
    color: ${(props) => props.theme.colors.white};
    background-color: ${(props) =>
      props.theme.colors.button.primary.background.hover};
    border-color: ${(props) =>
      props.theme.colors.button.primary.background.hover};
  }

  &&[disabled],
  &&[disabled]:hover {
    color: ${(props) => props.theme.colors.text.inverse};
    background-color: ${(props) => props.theme.colors.disabled};
    border-color: ${(props) => props.theme.colors.disabled};
  }
`

export const ConversationFooterDisclaimerStyled = styled.p`
  margin: 0;
  font-family: ${(props) => props.theme.fontFamily.body};
  font-size: ${(props) => props.theme.typography.pxToRem(12)};
  line-height: ${(props) => props.theme.typography.pxToRem(16)};
  color: ${(props) => props.theme.colors.text.tertiary};
  text-align: center;
`
